import { API } from "../config";
import { CreateCaseTypes, SearchHistoryTypes } from "../types";

export const getCourtDashboardSummary = async () => {
  const response = await API.get("/court-staff/summary");
  return response?.data?.data;
};
export const getCourtJudicialDivisions = async (page: number) => {
  const response = await API.get(
    `/court-staff/judicial/divisions?page=${page}`
  );
  return response?.data?.data;
};
export const getCourtSearchStats = async () => {
  const response = await API.get(`court-staff/stats/case`);
  return response?.data?.data;
};
export const getCourtJudicialDivisionById = async (id: number | undefined) => {
  const response = await API.get(`/court-staff/judicial-divisions/${id}`);
  return response?.data?.data;
};
export const getCourtAllCases = async (page: number) => {
  const response = await API.get(`/court-staff/cases?page=${page}`);
  return response?.data;
};
export const getCourtNotifications = async () => {
  const response = await API.get(`/court-staff/notifications`);
  return response?.data?.data;
};
export const createCase = async (data: CreateCaseTypes) => {
  const response = await API.post("/court-staff/cases", data);
  return response?.data;
};
export const editCase = async (
  data: CreateCaseTypes,
  id: number | undefined | null
) => {
  const response = await API.post(`/court-staff/cases/${id}/update`, data);
  return response?.data;
};
export const deleteJudicialDivision = async (id: number | undefined) => {
  const response = await API.delete(`/court-staff/judicial-divisions/${id}`);
  return response?.data;
};
export const getActivityLogsUnderCourt = async (page: number) => {
  const response = await API.get(`/court-staff/activity/logs?page=${page}`);
  return response?.data;
};
export const courtStaffCsvUpload = async (
  file: FormData,
  setProgress: Function
) => {
  const response = await API.post(`/court-staff/cases/csv`, file, {
    headers: { "Content-Type": "multipart/formdata" },

    onUploadProgress(progressEvent) {
      const total = progressEvent.total || 1; // progress count
      const progressCompleted = Math.round(
        (progressEvent.loaded / total) * 100
      ); // calculate the progress by percentage
      setProgress(progressCompleted);
    },
  });
  return response?.data;
};
// export const addUser = async (data: {
//   name: string;
//   email: string;
//   type: string;
// }) => {
//   const response = await API.post(`/admin/users`, data);
//   return response?.data;
// };
export const getCourtSinglectivityLogs = async (id: number | null) => {
  const response = await API.get(`/court-staff/activity/logs/${id}`);
  return response?.data?.data;
};
export const deleteCourtCase = async (id: number | undefined) => {
  const response = await API.delete(`/court-staff/cases/${id}`);
  return response?.data;
};

// export const getPlatformCharge = async () => {
//   const response = await API.get(`/admin/setting/charge`);
//   return response?.data?.data;
// };
// export const updatePlatformCharge = async (data: {
//   platform_charge: number;
// }) => {
//   const response = await API.post(`/admin/setting/charge`, data);
//   return response?.data;
// };
// export const createLga = async (data: { name: string }) => {
//   const response = await API.post(`/admin/states/1/lga`, data);
//   return response?.data;
// };
// export const updateLga = async (
//   id: number | undefined,
//   data: { name: string }
// ) => {
//   const response = await API.post(`/admin/lga/${id}/update`, data);
//   return response?.data;
// };
// export const deleteLga = async (id: number | undefined) => {
//   const response = await API.delete(`/admin/lga/${id}`);
//   return response?.data;
// };
